import { TransformNode } from '@babylonjs/core/Meshes/transformNode';
export const checkTransformNode = (value) => {
    if (!(value instanceof TransformNode)) {
        throw new Error(`Expected TransformNode, but received ${String(value)}`);
    }
    return value;
};
